import { Box, Button, Container, Flex, Group, Stack, Text, Title, Transition, Image, Card, Affix } from '@mantine/core';
import { Global } from '@mantine/styles';
import { useWindowScroll } from '@mantine/hooks';
import React from 'react';
import { useState } from 'react';
import { Scrollama, Step } from 'react-scrollama';
import bi_logo from '../assets/logo/bi.svg'
import jku_logo from '../assets/logo/jku-dark.png'
import vds_logo from '../assets/logo/vds-dark.png'
import moliere_1 from '../assets/onboarding/moliere_1.png'
import moliere_2 from '../assets/onboarding/moliere_2.png'
import moliere_3 from '../assets/onboarding/moliere_3.png'
import ranking_1 from '../assets/onboarding/ranking_1.png'
import ranking_2 from '../assets/onboarding/ranking_2.png'
import ranking_3 from '../assets/onboarding/ranking_3.png'
import ranking_4 from '../assets/onboarding/ranking_4.png'
import ranking_5 from '../assets/onboarding/ranking_5.png'
import story_1 from '../assets/onboarding/story_1.png'
import story_2 from '../assets/onboarding/story_2.png'
import story_3 from '../assets/onboarding/story_3.png'
import story_4 from '../assets/onboarding/story_4.png'
import story_5 from '../assets/onboarding/story_5.png'
import evidence_2 from '../assets/onboarding/evidence_2.png'
import evidence_3 from '../assets/onboarding/evidence_3.png'
import evidence_4 from '../assets/onboarding/evidence_4.png'
import evidence_5 from '../assets/onboarding/evidence_5.png'
import evidence_6 from '../assets/onboarding/evidence_6.png'
import evidence_7 from '../assets/onboarding/evidence_7.png'
import evidence_8 from '../assets/onboarding/evidence_8.png'
import evidence_9 from '../assets/onboarding/evidence_9.png'
import evidence_10 from '../assets/onboarding/evidence_10.png'
import evidence_11 from '../assets/onboarding/evidence_11.png'
import evidence_12 from '../assets/onboarding/evidence_12.png'
import evidence_13 from '../assets/onboarding/evidence_13.png'
import evidence_14 from '../assets/onboarding/evidence_14.png'
import evidence_15 from '../assets/onboarding/evidence_15.png'
import evidence_16 from '../assets/onboarding/evidence_16.png'
import evidence_17 from '../assets/onboarding/evidence_17.png'
import mesh from '../assets/onboarding/mesh.png'
import mesh_2 from '../assets/onboarding/mesh_2.png'
import paths_1 from '../assets/onboarding/paths_1.png'
import paths_2 from '../assets/onboarding/paths_2.png'
import paths_3 from '../assets/onboarding/paths_3.png'
import paths_4 from '../assets/onboarding/paths_4.png'
import paths_5 from '../assets/onboarding/paths_5.png'
import paths_6 from '../assets/onboarding/paths_6.png'
import paths_7 from '../assets/onboarding/paths_7.png'
import Logo from '../components/Logo'
import { FcBarChart, FcDatabase, FcDecision, FcFlowChart, FcGenericSortingDesc, FcMindMap, FcPuzzle, FcSerialTasks } from "react-icons/fc";
import { useNavigate } from 'react-router-dom';
import { IconArrowUp } from '@tabler/icons-react';

const Welcome = () => {
    const [scroll, scrollTo] = useWindowScroll();
    const [data, setData] = useState(-1);
    const [progress, setProgress] = useState(0);
    const steps = [4, 5, 6, 9, 10, 11, 12, 13, 14, 14.1, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]; // [0, 1, 2, 3, 
    const phases = [
        {
            text: "Pipeline",
            image: <FcFlowChart size="100%" />,
            description: <span><span style={{ fontFamily: 'Source Code Pro, monospace', color: "#f3f3f7" }}>mol<span style={{ color: '#47d0ae' }}>IE</span>re</span> — your pipeline — is our scriptwriter</span>,
            terminal: false
        },
        {
            text: "Hypotheses",
            image: <FcDatabase size="100%" />,
            description: <Text>He pens hypotheses with flair, complexity, and hidden insight</Text>,
            terminal: false
        },
        {
            text: "Visualization",
            image: <FcBarChart size="100%" />,
            description: <>
                <Text>At <Logo />, we take his scroll and bring it to life on stage</Text>
                <Text>Each chart is a scene, not just for show, but for scrutiny</Text>
            </>,
            terminal: false
        },
        {
            text: "Decision",
            image: <FcDecision size="100%" />,
            description: <Text>You are the audience, the critic, and the director</Text>,
            terminal: true
        }
    ]

    const navigate = useNavigate();

    const handleStart = () => {
        navigate('/app');
    };

    return (
        <>
            <Affix position={{ bottom: 20, right: 20 }}>
                <Transition transition="slide-up" mounted={scroll.y > 0}>
                    {(transitionStyles) => (
                        <Button
                            leftSection={<IconArrowUp size={16} />}
                            style={transitionStyles}
                            onClick={() => scrollTo({ y: 0 })}
                        >
                            Scroll to top
                        </Button>
                    )}
                </Transition>
            </Affix>
            <Global styles={{ body: { backgroundColor: '#34354a' } }} />
            <Container fluid px="lg">
                <Box pos="fixed" top={0} right={0} p="md" w="100%">
                    <Group justify="flex-end">
                        <Image src={jku_logo} style={{ width: "100%", maxWidth: "90px" }} />
                        <Image src={vds_logo} style={{ width: "100%", maxWidth: "90px" }} />
                        <Image src={bi_logo} style={{ width: "100%", maxWidth: "90px" }} />
                    </Group>
                </Box>

                {/* Title and intro */}
                <Stack align="center" mt={100} style={{ height: '100vh' }}>
                    <Title order={1} size='2vw' c="#f3f3f7" fw={1000}>Welcome To <Logo />!</Title><br></br>
                    <Text c="#dce4f5" ta="center" size='1vw'>
                        <Logo /> is a visual tool helps you explore and interpret the output of a computational pipeline aimed at hypothesis generation for indication expansion.<br></br>
                        <br></br>
                        Instead of navigating complex spreadsheet files, <Logo /> provides intuitive visualizations to help you identify and validate trusted candidates for further exploration.
                    </Text><br></br>
                    <Button
                        component="a"
                        color="blue"
                        size="xl"
                        onClick={handleStart}
                    >
                        Get started
                    </Button>
                    <Text c="dimmed" size="lg">Scroll to learn more ↓</Text>
                </Stack>

                {/* Layout with scrollable content + sticky value */}
                <Flex mt="xl" gap="xl" align="start">
                    {/* Scrollable section */}
                    <Box style={{
                        /* leave exactly the card width + a small gutter */
                        paddingRight: `calc(min(${data > 4 ? '60vw' : '50vw'}, 1913px) + 24px)`,
                        /* keep the content centred inside the space that is left */
                        marginInline: 'auto',
                    }} >
                        <Scrollama
                            onStepEnter={({ data }) => setData(data)}
                            onStepExit={({ direction, data }) => {
                                if (direction === 'up' && data === steps[0]) setData(-1);
                            }}
                            progress
                            onStepProgress={({ progress }) => setProgress(progress)}
                            offset="400px"
                        >
                            {steps.map((value) => {
                                const isVisible = value === data;
                                return (
                                    <Step data={value} key={value}>
                                        <Box
                                            style={{
                                                minHeight: '100vh',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                            }}
                                        >
                                            {/* {value < 4 && <Stack align="center" style={{ textAlign: 'center' }}>
                                                <Text c="dimmed" size='1.3vw' >{phases[value].description}</Text>
                                                <Box
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        transform: `scale(${isVisible ? 1 - progress : 0.5})`,
                                                        transition: 'transform 0.2s ease-out',
                                                    }}
                                                >
                                                    {phases[value].image}
                                                </Box>

                                                <Transition
                                                    mounted={!phases[value].terminal && progress > 0.6}
                                                    transition="slide-up"
                                                    duration={400}
                                                    timingFunction="ease"
                                                >
                                                    {(styles) => (
                                                        <div
                                                            style={{
                                                                ...styles,
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center'
                                                            }}
                                                        >
                                                            <FcDown size="80%" />
                                                        </div>
                                                    )}
                                                </Transition>
                                            </Stack>} */}
                                            {value == 6 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    Your journey starts with a ranked list of indications, generated by <span><span style={{ fontFamily: 'Source Code Pro, monospace', color: "#f3f3f7" }}>mol<span style={{ color: '#47d0ae' }}>IE</span>re</span></span>  using multiple data streams.
                                                </Text>
                                            }
                                            {value == 9 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    Each indication is ranked by a <span><span style={{ fontFamily: 'Source Code Pro, monospace', color: "#f3f3f7" }}>mol<span style={{ color: '#47d0ae' }}>IE</span>re</span></span> score: M_Score
                                                    <Text>It’s a weighted blend of data stream signals.</Text>
                                                </Text>
                                            }
                                            {value == 10 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    We break down each indication’s score by data stream for you to see where the score is coming from.
                                                </Text>
                                            }
                                            {value == 11 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Explore the scores in bigger biological landscape</Text><br></br>
                                                    <Text>Use MeSH Explorer to browse indications in the context of the disease ontology.</Text><br></br>
                                                    <Text>Navigate by disease families, spot patterns, and find hidden insights that ranking alone might miss.</Text>
                                                </Text>
                                            }
                                            {value == 13 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Here, we unpack the evidence behind the ranking</Text>
                                                    <Text>gene by gene, stream by stream</Text>
                                                </Text>
                                            }
                                            {value == 14 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Each gene contributes evidence across multiple data streams.</Text><br></br>
                                                </Text>
                                            }
                                            {value == 14.1 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>These are quantified, saturated, and passed into weighted scoring.</Text>
                                                </Text>
                                            }
                                            {value == 15 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Some signals boost an indication’s M_score. Others hold it back.</Text><br></br>
                                                    <Text>Such as gene showing down-regulated expression impacting the M_score negatively</Text>
                                                </Text>
                                            }
                                            {value == 16 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Click any stream segment to explore the detailed evidence: publications, data points, scores.</Text>
                                                </Text>
                                            }
                                            {value == 18 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Here, we trace the shortest paths linking your query genes to the indication</Text><br></br>
                                                    <Text>paths woven through biological knowledge from PrimeKG.</Text>
                                                </Text>
                                            }
                                            {value == 19 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Thousands of paths?</Text><br></br>
                                                    <Text>That would be chaos.</Text>
                                                </Text>
                                            }
                                            {value == 20 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Instead, we group them into meta paths</Text><br></br>
                                                    <Text>recurring patterns of biological relationships you can easily explore</Text>
                                                </Text>
                                            }
                                            {value == 21 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Open a meta path to reveal the routes inside.</Text>
                                                </Text>
                                            }
                                            {value == 22 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Use filters to sharpen your view.</Text>
                                                </Text>
                                            }
                                            {value == 23 &&
                                                <Text c="dimmed" ta="center" size='1.3vw'>
                                                    <Text>Click any meta node to see a breakdown: which elements dominate this pattern.</Text>
                                                </Text>
                                            }
                                        </Box>
                                    </Step>
                                );
                            })}
                        </Scrollama>
                    </Box>

                    {/* Sticky side box with current step value */}
                    <Transition mounted={data > -1 && data < 4} transition="fade" duration={400} timingFunction="ease">
                        {(styles) => (
                            <Card style={{
                                ...styles,
                                position: 'fixed',
                                right: "3%",
                                top: '55%',
                                transform: 'translateY(-50%)',
                                backgroundColor: '#34354a',
                                width: '45%',
                                maxWidth: '1913px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 8,
                                zIndex: 10,
                                height: 'auto',
                                padding: 0,
                            }} shadow="md" padding="lg" radius="md" withBorder>
                                <Image
                                    src={moliere_1}
                                    radius="md"
                                    style={{
                                        opacity: data === 0 || data === 1 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 0 || data === 1 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={moliere_2}
                                    radius="md"
                                    style={{
                                        opacity: data === 2 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 2 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={moliere_3}
                                    radius="md"
                                    style={{
                                        opacity: data === 3 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 3 ? 'relative' : 'absolute',
                                    }}
                                />
                            </Card>
                        )}
                    </Transition>

                    {/* Sticky side box with current step value */}
                    <Transition mounted={data > 4 && data <= 11} transition="fade" duration={400} timingFunction="ease">
                        {(styles) => (
                            <Card style={{
                                ...styles,
                                position: 'fixed',
                                right: "3%",
                                top: '55%',
                                transform: 'translateY(-50%)',
                                backgroundColor: '#34354a',
                                width: '55%',
                                maxWidth: '1913px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 8,
                                zIndex: 10,
                                height: 'auto',
                                padding: 0,
                                opacity: data > 5 ? 1 : 0
                            }} shadow="md" padding="lg" radius="md" withBorder>
                                <Image
                                    src={ranking_1}
                                    radius="md"
                                    style={{
                                        opacity: data === 6 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 6 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={ranking_2}
                                    radius="md"
                                    style={{
                                        opacity: data === 6 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '0.5s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={ranking_3}
                                    radius="md"
                                    style={{
                                        opacity: data === 6 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '1.5s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={ranking_4}
                                    radius="md"
                                    style={{
                                        opacity: data === 9 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 9 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={ranking_5}
                                    radius="md"
                                    style={{
                                        opacity: data === 10 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 10 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={mesh}
                                    radius="md"
                                    style={{
                                        opacity: data === 11 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 11 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={mesh_2}
                                    radius="md"
                                    style={{
                                        opacity: data === 11 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '1s',
                                        position: 'absolute',
                                    }}
                                />
                            </Card>
                        )}
                    </Transition>

                    {/* Sticky side box with current step value */}
                    <Transition mounted={data >= 13 && data <= 16} transition="fade" duration={400} timingFunction="ease">
                        {(styles) => (
                            <Card style={{
                                ...styles,
                                position: 'fixed',
                                right: "3%",
                                top: '55%',
                                transform: 'translateY(-50%)',
                                backgroundColor: '#34354a',
                                width: '55%',
                                maxWidth: '1913px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 8,
                                zIndex: 10,
                                height: 'auto',
                                padding: 0,
                            }} shadow="md" padding="lg" radius="md" withBorder>
                                <Image
                                    src={evidence_2}
                                    radius="md"
                                    style={{
                                        opacity: data === 13 || data === 14 || data === 14.1 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 13 || data === 14 || data === 14.1 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_14}
                                    radius="md"
                                    style={{
                                        opacity: data === 14 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '0.5s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_15}
                                    radius="md"
                                    style={{
                                        opacity: data === 14 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '1.5s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_16}
                                    radius="md"
                                    style={{
                                        opacity: data === 14 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '2s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_17}
                                    radius="md"
                                    style={{
                                        opacity: data === 14 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '2.5s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_3}
                                    radius="md"
                                    style={{
                                        opacity: data === 14.1 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '0.5s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_4}
                                    radius="md"
                                    style={{
                                        opacity: data === 14.1 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '1s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_5}
                                    radius="md"
                                    style={{
                                        opacity: data === 14.1 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '1.5s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_6}
                                    radius="md"
                                    style={{
                                        opacity: data === 14.1 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '2s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_7}
                                    radius="md"
                                    style={{
                                        opacity: data === 15 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 15 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_8}
                                    radius="md"
                                    style={{
                                        opacity: data === 15 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '0.5s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_9}
                                    radius="md"
                                    style={{
                                        opacity: data === 15 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '1s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_10}
                                    radius="md"
                                    style={{
                                        opacity: data === 16 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 16 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_11}
                                    radius="md"
                                    style={{
                                        opacity: data === 16 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '2s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_12}
                                    radius="md"
                                    style={{
                                        opacity: data === 16 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '4s',
                                        position: 'absolute',
                                    }}
                                />
                                <Image
                                    src={evidence_13}
                                    radius="md"
                                    style={{
                                        opacity: data === 16 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '6s',
                                        position: 'absolute',
                                    }}
                                />
                            </Card>
                        )}
                    </Transition>

                    {/* Sticky side box with current step value */}
                    <Transition mounted={data >= 18 && data <= 23} transition="fade" duration={400} timingFunction="ease">
                        {(styles) => (
                            <Card style={{
                                ...styles,
                                position: 'fixed',
                                right: "3%",
                                top: '55%',
                                transform: 'translateY(-50%)',
                                backgroundColor: '#34354a',
                                width: '55%',
                                maxWidth: '1913px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 8,
                                zIndex: 10,
                                height: 'auto',
                                padding: 0,
                            }} shadow="md" padding="lg" radius="md" withBorder>
                                <Image
                                    src={paths_1}
                                    radius="md"
                                    style={{
                                        opacity: data === 18 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 18 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={paths_2}
                                    radius="md"
                                    style={{
                                        opacity: data === 19 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 19 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={paths_3}
                                    radius="md"
                                    style={{
                                        opacity: data === 20 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 20 ? 'relative' : 'absolute',
                                    }}
                                />
                                <Image
                                    src={paths_4}
                                    radius="md"
                                    style={{
                                        opacity: data === 21 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 21 ? 'relative' : 'absolute'
                                    }}
                                />
                                <Image
                                    src={paths_5}
                                    radius="md"
                                    style={{
                                        opacity: data === 21 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        transitionDelay: '0.5s',
                                        position: 'absolute'
                                    }}
                                />
                                <Image
                                    src={paths_6}
                                    radius="md"
                                    style={{
                                        opacity: data === 22 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 22 ? 'relative' : 'absolute'
                                    }}
                                />
                                <Image
                                    src={paths_7}
                                    radius="md"
                                    style={{
                                        opacity: data === 23 ? 1 : 0,
                                        transition: 'opacity 400ms ease',
                                        position: data === 23 ? 'relative' : 'absolute'
                                    }}
                                />
                            </Card>
                        )}
                    </Transition>

                    <Transition mounted={data === 4} transition="fade" duration={600} timingFunction="ease">
                        {(styles) => (
                            <Group style={{
                                ...styles,
                                position: 'fixed',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                color: "#f3f3f7",
                            }}>
                                <FcSerialTasks size="10%" />
                                <Text style={{
                                    fontSize: 50,
                                    color: "#f3f3f7",

                                }} >
                                    Your Journey From <span style={{ color: "#47d0ae" }}>Data</span> to <span style={{ color: "#fdb812" }}>Decision</span>
                                </Text>
                            </Group>
                        )}
                    </Transition>

                    <Transition mounted={data === 5} transition="fade" duration={600} timingFunction="ease">
                        {(styles) => (
                            <Stack style={{
                                ...styles,
                                position: 'fixed',
                                right: "10%",
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '80%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                color: "#f3f3f7",
                            }} justify='center' align='center'>
                                <Group>
                                    <FcGenericSortingDesc size={50} />
                                    <Text style={{
                                        fontSize: 50,
                                        color: "#f3f3f7",

                                    }} >
                                        Explore the Rankings
                                    </Text>
                                </Group>
                                <Text style={{
                                    fontSize: 20
                                }} c="dimmed" ta="center">
                                    The <span style={{ fontFamily: 'Source Code Pro, monospace', fontSize: 20, color: "#f3f3f7" }}>mol<span style={{ color: '#47d0ae' }}>IE</span>re</span> pipeline has done the heavy lifting. It analyzed diverse data sources — from scientific literature to biobank studies — and generated a ranked list of potential indications for your query. This list is your starting point.
                                </Text>
                            </Stack>
                        )}
                    </Transition>

                    <Transition mounted={data === 12} transition="fade" duration={600} timingFunction="ease">
                        {(styles) => (
                            <Stack style={{
                                ...styles,
                                position: 'fixed',
                                right: "10%",
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '80%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                color: "#f3f3f7",
                            }} justify='center' align='center'>
                                <Group>
                                    <FcPuzzle size={50} />
                                    <Text style={{
                                        fontSize: 50,
                                        color: "#f3f3f7",

                                    }} >
                                        See the Evidence
                                    </Text>
                                </Group>
                                <Text style={{
                                    fontSize: 20
                                }} c="dimmed" ta="center">
                                    Reveal how the M_score is constructed — from gene-level contributions through weighted stream aggregation — and enable exploration of supporting evidence.
                                </Text>
                            </Stack>
                        )}
                    </Transition>

                    <Transition mounted={data === 17} transition="fade" duration={600} timingFunction="ease">
                        {(styles) => (
                            <Stack style={{
                                ...styles,
                                position: 'fixed',
                                right: "10%",
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '80%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                color: "#f3f3f7",
                            }} justify='center' align='center'>
                                <Group>
                                    <FcMindMap size={50} />
                                    <Text style={{
                                        fontSize: 50,
                                        color: "#f3f3f7",

                                    }} >
                                        Follow the Paths Beyond Scores
                                    </Text>
                                </Group>
                                <Text style={{
                                    fontSize: 20
                                }} c="dimmed" ta="center">
                                    Unlock deeper insights by going beyond just scores – we trace the shortest paths between your query genes and the target indication, through PrimeGK, helping you connect the dots in a whole new way.
                                </Text>
                            </Stack>
                        )}
                    </Transition>

                    <Transition mounted={data >= 24 && data < 30} transition="fade" duration={600} timingFunction="ease">
                        {(styles) => (
                            <Stack
                                style={{
                                    ...styles,
                                    position: 'fixed',
                                    right: "10%",
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '80%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    height: '100%',
                                    color: "#f3f3f7",
                                }}
                            >
                                <Text style={{ fontSize: '2vw' }} c="#f3f3f7" ta="center">
                                    Bringing the Story Together
                                </Text>
                                <div style={{ position: 'relative', width: '70%', height: '70vh' }}>
                                    <Image
                                        src={story_1}
                                        style={{
                                            position: 'absolute',
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            opacity: data === 25 ? 1 : 0,
                                            transition: 'opacity 400ms ease',
                                        }}
                                    />
                                    <Image
                                        src={story_2}
                                        style={{
                                            position: 'absolute',
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            opacity: data === 26 ? 1 : 0,
                                            transition: 'opacity 400ms ease',
                                        }}
                                    />
                                    <Image
                                        src={story_3}
                                        style={{
                                            position: 'absolute',
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            opacity: data === 27 ? 1 : 0,
                                            transition: 'opacity 400ms ease',
                                        }}
                                    />
                                    <Image
                                        src={story_4}
                                        style={{
                                            position: 'absolute',
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            opacity: data === 28 ? 1 : 0,
                                            transition: 'opacity 400ms ease',
                                        }}
                                    />
                                    <Image
                                        src={story_5}
                                        style={{
                                            position: 'absolute',
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            opacity: data === 29 ? 1 : 0,
                                            transition: 'opacity 400ms ease',
                                        }}
                                    />
                                </div>
                                {data === 25 && <Text style={{ fontSize: '1.4vw' }} c="dimmed" ta="center">
                                    <span style={{ fontFamily: 'Source Code Pro, monospace', color: "#f3f3f7" }}>mol<span style={{ color: '#47d0ae' }}>IE</span>re</span> processes diverse biomedical data streams
                                </Text>}
                                {data === 26 && <Text style={{ fontSize: '1.4vw' }} c="dimmed" ta="center">
                                    collecting gene-level evidence and producing per-indication confidence scores, broken down by stream.
                                </Text>}
                                {data === 27 && <Text style={{ fontSize: '1.4vw' }} c="dimmed" ta="center">
                                    Use <Logo /> to explore indications by score, filter by MeSH structure, and form your initial shortlist.
                                </Text>}
                                {data === 28 && <Text style={{ fontSize: '1.4vw' }} c="dimmed" ta="center">
                                    Understand how each data stream and gene contributed to the score.
                                </Text>}
                                {data === 29 && <Text style={{ fontSize: '1.4vw' }} c="dimmed" ta="center">
                                    Contextualize each candidate indication with biomedical knowledge graph paths.
                                </Text>}
                            </Stack>
                        )}
                    </Transition>

                    <Transition mounted={data === 30} transition="fade" duration={600} timingFunction="ease">
                        {(styles) => (
                            <Stack style={{
                                ...styles,
                                position: 'fixed',
                                right: "10%",
                                top: '50%',
                                transform: 'translateY(-50%)',
                                width: '80%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                color: "#f3f3f7",
                            }} justify='center' align='center'>
                                <Text style={{
                                    fontSize: '2.5vw',
                                    color: "#f3f3f7",
                                }} ta="center" >
                                    <Logo /> brings together the pieces so you can decide with confidence.
                                </Text>
                                <Button
                                    component="a"
                                    color="blue"
                                    size="xl"
                                    onClick={handleStart}
                                >
                                    Get started
                                </Button>
                            </Stack>
                        )}
                    </Transition>
                </Flex>
            </Container>
        </>
    );
};

export default Welcome;
